import useBrowseState from "../../hooks/useBrowseState";
import { plural } from "../../utils/format";
import Breadcrumb from "./Breadcrumb";
import SizeFilter from "./SizeFilter";
import SortSelect from "./SortSelect";

function resultLabel(count, { department, subcategory }) {
  const noun = `${count} Item${count === 1 ? "" : "s"}`;
  if (subcategory !== "All") return `${noun} for ${subcategory === "Kid" ? "Kids" : subcategory}`;
  if (department !== "All") return `${noun} for ${department}`;
  return noun;
}

// Breadcrumb, category/size filters, result count and sort for the current browse state.
export default function BrowseFilters({ count }) {
  const state = useBrowseState();

  return (
    <>
      <Breadcrumb />
      <SizeFilter />
      <div id="v129ResultRow">
        <div id="v129ResultCount" aria-live="polite">
          {state.latest ? plural(count, "Item") : resultLabel(count, state)}
        </div>
        <SortSelect />
      </div>
    </>
  );
}
